import { NgModule } from '@angular/core';
import { MatButtonModule, MatButtonToggleModule, MatCardModule,
         MatCheckboxModule, MatDialogModule, MatExpansionModule,
         MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule,
         MatSelectModule, MatTabsModule, MatToolbarModule,
       } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatToolbarModule,
  ],
  exports: [
    BrowserAnimationsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatToolbarModule,
  ],
})
export class MatModule { }



// WEBPACK FOOTER //
// ./src/app/core/material/mat.module.ts